export enum FREQUENCY {
  SINGLE = 'Single',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  ANNUAL = 'Annual',
}

export enum FREQUENCY_COMBOS {
  SINGLE = 'Single',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  ANNUAL = 'Annual',
  MONTHLY_AND_SINGLE = 'Monthly and single',
  QUARTERLY_AND_SINGLE = 'Quarterly and single',
  ANNUAL_AND_SINGLE = 'Annual and single',
}

// Server frequency values can arrive as RecurringFrequencyEnum (ALL CAPS, e.g.
// 'MONTHLY') or as a FREQUENCY value (Title Case, e.g. 'Monthly'). Normalise to a
// FREQUENCY value so it matches the Frequency select options. Unknown/empty -> Single.
export const toFrequency = (value?: string | null): FREQUENCY => {
  switch (value?.toUpperCase()) {
    case 'MONTHLY':
      return FREQUENCY.MONTHLY;
    case 'QUARTERLY':
      return FREQUENCY.QUARTERLY;
    case 'ANNUAL':
      return FREQUENCY.ANNUAL;
    default:
      return FREQUENCY.SINGLE;
  }
};

export default FREQUENCY;
